// removed by extract-text-webpack-plugin
module.exports = {"loginForm":"LoginForm__loginForm__3HpEG","headline":"LoginForm__headline__2lysS","alertsMb":"LoginForm__alertsMb__kBPCR","submitButton":"LoginForm__submitButton__2Jjah","paragraph":"LoginForm__paragraph__3aJtM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/LoginForm.css
// module id = 1492
// module chunks = 0